import React, { useState } from "react";
import useLogIn from "../../Hooks/useLogIn";
import Email from "./Email";
import { useNavigate } from "react-router-dom";
import {
  AuthStepsHeading,
  AuthStepsParagraph,
  ButtonWithIcon,
  OrBetweenButtons,
} from "../../constents/components";
import useGoogleLogin from "../../Hooks/Auth/useGoogleLogin";
import logo from "../../Assets/logo.png";
import loginImage from "../../Assets/loginImage.svg";
import Illustrations from "./Illustrations";
import googleIcon from "../../Assets/SocialIcons/googleIcon.svg";
import useRouteFunctions from "../../Hooks/Routes/useRouteFunctions";
import Password from "./Password";
import { RedirectUrlGetter } from "../../Utils/functions";

const Login = () => {
  const Heading = "Sign In to Continue";
  const SubHeading = "Begin your journey toward landing your dream job!";
  const Navigate = useNavigate();
  const onSucessLogin = () => Navigate("/dashboard");
  // const onSucessLogin = () => RedirectUrlGetter();

  const loginWithGoogle = useGoogleLogin(onSucessLogin);

  const valuesInitial = { email: "", password: "" };
  const errorsInitial = {
    emailTextError: false,
    wrongPasswordCount: 0,
    message: "",
  };
  const [values, setValues] = useState(valuesInitial);
  const [errors, setErrors] = useState(errorsInitial);

  const { goToForgotPasswordPage } = useRouteFunctions();
  const setPassword = (value) => {
    setErrors((pre) => {
      return { ...pre, message: "" };
    });
    setValues((pre) => {
      return { ...pre, password: value };
    });
  };
  const setEmail = (value) => {
    setErrors((pre) => {
      return { ...pre, message: "" };
    });
    setValues((pre) => {
      return { ...pre, email: value };
    });
  };
  const setEmailValidation = (bool) => {
    setErrors((pre) => {
      return { ...pre, emailTextError: bool };
    });
  };

  const [loading, error, logInFunction] = useLogIn(onSucessLogin);

  const onLogIn = () => {
    setErrors((pre) => ({
      ...pre,
      message: "",
    }));

    logInFunction(values.email, values.password)
      .then(() => {})
      .catch((err) => {
        setErrors((pre) => ({
          ...pre,
          message: err || "Something went wrong",
        }));
      });
  };

  return (
    <div className=" flex flex-col lg:flex-row min-h-screen">
      <Illustrations
        imgIcon={loginImage}
        mainHeading={"Let recruiters see the superstar you are!!!"}
        subHeading={
          "Stand out and shine—let recruiters see your true potential!"
        }
        bottomText={""}
      ></Illustrations>
      <div className="flex flex-col flex-1 p-4  bg-white items-center lg:pt-16 ">
        <div className="flex items-center flex-col">
          <img
            className=" w-44 hidden md:block mb-4"
            src={logo}
            alt={"logo-Icon"}
          />

          <form
            onSubmit={onLogIn}
            className="flex items-center flex-col min-h-[50vh]"
          >
            <AuthStepsHeading text={Heading} />
            <AuthStepsParagraph text={SubHeading} />

            <div className=" flex flex-col gap-4 my-4 w-full">
              <Email
                email={values.email}
                setEmail={setEmail}
                setEmailValid={setEmailValidation}
              />
              <Password
                password={values.password}
                setPassword={(value) => setPassword(value)}
                setPasswordError={() => {}}
              />
            </div>

            <div className=" flex justify-end w-full">
              <p
                className="text-xs text-text-color cursor-pointer text-end"
                onClick={goToForgotPasswordPage}
              >
                Forgot Password?
              </p>
            </div>

            {errors?.message && (
              <p className="text-sm mt-2 font-semibold text-[#ff0000]">
                {errors?.message}
              </p>
            )}
            {
              <ButtonWithIcon
                onButtonClick={onLogIn}
                onkeyDown={(e) => {
                  if (e.key === "Enter") {
                    onLogIn();
                  }
                }}
                text={loading ? "Loading" : "Log In"}
                classNames={"text-white w-full mt-6 p-4 bg-[#FF5D10]"}
              />
            }
            <div className=" mt-6">
              <p className=" text-gray-400">
                Do not have an account ?{" "}
                <span
                  className="text-primary-color-900  font-semibold cursor-pointer"
                  onClick={() => Navigate("/auth/register")}
                >
                  Sign Up
                </span>{" "}
              </p>
              {/* <p className='pt-1 text-gray-400 text-xs'>By continuing, you agree to Termns of Use and Privacy Policy  </p> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

// <OrBetweenButtons />
//                         <button
//                             className='w-full mb-4 p-4  rounded-full outline-none border-[0.08rem] border-inputbox-border-color flex items-center gap-2 justify-center'
//                             onClick={() => loginWithGoogle()}
//                             style={{
//                                 "box-shadow": "0px 2px 2px 0px rgba(0, 0, 0, 0.08)",
//                             }}
//                         >
//                             <img src={googleIcon} alt="googleIcon" />
//                             <span>Login with Google</span>
//                         </button>
